<template>
  <div id="app">
    <Login v-if="!loginData.token" :loginData.sync='loginData' />
    <Connecting v-else @callbackFun="callbackFun" />
  </div>
</template>

<script>
  // import bootstrap from 'bootstrap'
  import Login from './components/Login.vue'
  import Connecting from './components/Connecting.vue'

  export default {
    name: 'App',
    components: {
      Login,
      Connecting,
    },
    beforeCreate() {
      document.getElementsByTagName('html')[0].className = 'htmlClass'
      document.getElementsByTagName('body')[0].className = 'bodyClass'
    },
    methods: {
      callbackFun(val) {
        this.loginData = val || {}
      },
    },
    data() {
      return {
        loginData: sessionStorage.getItem('loginData') ?
          JSON.parse(sessionStorage.getItem('loginData')) :
          {},
      }
    },
  }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100vh;
  }

  .bodyClass {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }

  .htmlClass {
    height: -webkit-fill-available;
  }
</style>